import type { PainTrendConfig } from "@/lib/schema";
import type { WidgetSettingsEditorProps } from "@/widgets/types";

type Props = WidgetSettingsEditorProps<PainTrendConfig>;

export function SettingsEditor({ config, onChange, errors = {} }: Props) {
  return (
    <div
      className="widget-settings"
      data-testid={`widget-settings-${config.id}`}
    >
      <div className="setting-row">
        <label className="setting-label" htmlFor={`label-${config.id}`}>
          Tittel
          <small>
            Viser snittet av smertenivået per uke de siste 12 ukene, med laveste
            og høyeste nivå den uka.
          </small>
        </label>
        <div className="setting-control">
          <input
            id={`label-${config.id}`}
            className="input"
            type="text"
            value={config.label}
            onChange={(e) => onChange({ label: e.target.value })}
            data-testid="widget-label-input"
          />
          {errors.label ? (
            <p className="field-error" data-testid="widget-error-label">
              {errors.label}
            </p>
          ) : null}
        </div>
      </div>
    </div>
  );
}
